<div class="summary-title">{{ 'deliveryDefenseScoreSummary.title' | translate }}</div>
<div class="address">
    <span>{{ addressString }}</span>
</div>
<div [innerHTML]="'deliveryDefenseScoreSummary.' + confidenceLevel + '.message' | translate: { addressType: addressType }"
     class="message">
</div>

<div class="linear-gauge-container no-print">
    <upsc-confidence-gauge [mode]="'compact'"
                           [shouldShowCoverageRange]="false"
                           [shouldShowMinMaxValues]="true"
                           [value]="ddScore"></upsc-confidence-gauge>
</div>
